import { render, staticRenderFns } from "./AdminCategory.vue?vue&type=template&id=1f750fd5"
import script from "./AdminCategory.vue?vue&type=script&lang=js"
export * from "./AdminCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports